import { format } from 'date-fns';
import Analytics from 'helpers/analytics';
import { useState, useEffect } from 'react';
import { changeDateCampaign } from './ModalChangeDate.services';
import { useToast } from '@welbe/web-design-system';

interface UseChangeNewDateProps {
	typeProps?: any;
	campaignId?: any;
	communicationId?: string;
	onRetryDates?: () => void;
	onToggleModal?: () => void;
}

export const useChangeNewDate = ({
	typeProps,
	campaignId,
	communicationId,
	onRetryDates,
	onToggleModal,
}: UseChangeNewDateProps) => {
	const { toast } = useToast();
	const [form, setForm] = useState<any>({
		date: '',
		hour: '',
	});
	const [isLoading, setLoading] = useState<boolean>(false);

	const handleChangeCalendar = (selectedDate: any) => {
		if (selectedDate) {
			form.date = selectedDate;
		}
	};

	const handleChangeHour = (value: string) => {
		if (value) {
			form.hour = value;
		}
	};

	const handleSave = async () => {
		setLoading(true);
		try {
			await changeDateCampaign({
				campaignId,
				communicationId,
				date: form.date,
				time: form.hour,
			});
			Analytics.track('campaign', 'save-change-end-date-campaign', {
				changedDate: new Date(form.date),
			});
			onRetryDates && onRetryDates();
			onToggleModal && onToggleModal();
		} catch (error) {
			toast.error('No fue possible guardar la nueva data');
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		const initialHour = typeProps.initialValue
			? format(new Date(typeProps.initialValue), 'HH:mm')
			: '';

		setForm({
			date: typeProps.initialValue,
			hour: initialHour,
		});
	}, [typeProps.initialValue]);

	return {
		form,
		handleChangeCalendar,
		handleChangeHour,
		handleSave,
		isLoading,
	};
};
